<template>
  <div class="session">
    <div>Session id: {{ session._id }}</div>
    <div>Start time: {{ startTime }}</div>
    <button @click="rectifySession">Rectify session</button>
    <div class="usersInSessionTitle">Users in session</div>
    <div class="usersInSession">
      <div class="userInSession" v-if="user1" :key="user1._id">
        <div>
          Display name:
          <button @click="selectUser(user1._id)">
            {{ user1.displayName }}
          </button>
        </div>
        <div>userID: {{ user1._id }}</div>
        <div class="join-statuses">
          <div v-if="!getUserStamps(user1._id)">
            User has not joined session
          </div>
          <div v-else>
            <div v-for="(stamp, index) in getUserStamps(user1._id)" :key="index">
              <div v-if="stamp.type == 'join'" class="user-stamp">
                User <span class="joined stamp--base">joined</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'enter'" class="user-stamp">
                User <span class="enter stamp--base">entered</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'disconnected'" class="user-stamp">
                User <span class="disconnect stamp--base">disconnected</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'mic_on'" class="user-stamp">
                User <span class="micOn stamp--base">mic on</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'mic_off'" class="user-stamp">
                User <span class="micOff stamp--base">mic off</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'cam_on'" class="user-stamp">
                User <span class="camOn stamp--base">cam on</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'cam_off'" class="user-stamp">
                User <span class="camOff stamp--base">cam off</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'leave'" class="user-stamp">
                User <span class="leave stamp--base">leave</span>{{ ` at ${stamp.time}` }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="userInSession" v-if="user2" :key="user2._id">
        <div>
          Display name:
          <button @click="selectUser(user2._id)">
            {{ user2.displayName }}
          </button>
        </div>
        <div>userID: {{ user2._id }}</div>
        <div class="join-statuses">
          <div v-if="!getUserStamps(user2._id)">
            User has not joined session
          </div>
          <div v-else>
            <div v-for="(stamp, index) in getUserStamps(user2._id)" :key="index">
              <div v-if="stamp.type == 'join'" class="user-stamp">
                User <span class="joined stamp--base">joined</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'enter'" class="user-stamp">
                User <span class="enter stamp--base">entered</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'disconnected'" class="user-stamp">
                User <span class="disconnect stamp--base">disconnected</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'mic_on'" class="user-stamp">
                User <span class="micOn stamp--base">mic on</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'mic_off'" class="user-stamp">
                User <span class="micOff stamp--base">mic off</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'cam_on'" class="user-stamp">
                User <span class="camOn stamp--base">cam on</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'cam_off'" class="user-stamp">
                User <span class="camOff stamp--base">cam off</span>{{ ` at ${stamp.time}` }}
              </div>
              <div v-else-if="stamp.type == 'leave'" class="user-stamp">
                User <span class="leave stamp--base">leave</span>{{ ` at ${stamp.time}` }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { getUser } from "../InternalHelpers";
export default {
  name: "PastSession",
  props: {
    session: Object,
    allowedUserViewing: Boolean,
  },
  data() {
    return {
      UID_1: null,
      UID_2: null,

      user1: null,
      user2: null,

      user1Stamps: null,
      user2Stamps: null,
    };
  },
  computed: {
    startTime() {
      return format(new Date(this.session.dateTime), `MMMM d, y, HH:mm`);
    },
  },
  async created() {
    await this.getAndSetUserDatas();
  },
  methods: {
    selectUser(id) {
      this.$emit("selectUser", id);
    },
    async rectifySession() {
      this.$emit("rectifySession", this.session._id);
    },
    async getAndSetUserDatas() {
      const session = this.session;
      if (session && session.UIDs) {
        for (var i = 0; i < session.UIDs.length; i++) {
          let UID = session.UIDs[i];
          UID = UID.toString();
          if (!this.UID_1) {
            this.UID_1 = UID;
          } else {
            this.UID_2 = UID;
          }
        }
      }

      if (this.UID_1) {
        this.user1 = await getUser(this.UID_1);
      }

      if (this.UID_2) {
        this.user2 = await getUser(this.UID_2);
      }
    },
    getUserStamps(userID) {
      let userStamps = [];
      if (this.session && this.session.timestamps && this.session.timestamps.length) {
        for (var i = 0; i < this.session.timestamps.length; i++) {
          let stamp = this.session.timestamps[i];
          if (stamp.type === "rematched") continue;
          console.log("THE STAMP: ", stamp);
          let UID = stamp.UID;
          UID = UID.toString();
          if (UID == userID) {
            let stampObject = {
              UID: UID,
              type: stamp.type,
              time: format(new Date(stamp.stamp), `MMMM d, y, HH:mm:ss`),
            };
            userStamps.push(stampObject);
          }
        }
      }
      if (userStamps && userStamps.length) {
        return userStamps;
      }

      return null;
    },
  },
  watch: {
    "session._id": {
      async handler() {
        this.UID_1 = null;
        this.UID_2 = null;
        this.user1 = null;
        this.user2 = null;
        await this.getAndSetUserDatas();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.user-stamp {
  border: 1px solid;
  margin: 5px 0px;
  padding: 8px 2px;
  font-size: 14px;
  text-align: center;
  background-color: azure;
}
.joined {
  background-color: #0000b9;
}
.leave {
  background-color: #9700b3;
}
.enter {
  background-color: #12ae12;
}
.disconnect {
  background-color: #b40000;
}
.stamp--base {
  padding: 0px 4px;
  color: white;
}
.micOn,
.camOn {
  background-color: #008fb4;
}
.micOff,
.camOff {
  background-color: #2a0007;
}
</style>
